export const serviceOrderMock = {
  id: 'test-order-id',
  serviceCaseId: 'test-service-case-id',
  serviceOrderVariantId: 'test-variant-id',
  number: 'ORD-001',
  state: 'OPEN',
  name: 'Test Order',
  mileage: 50000,
  fuelTank: 0.5,
  completionAt: null,
  note: null,
  cancelReason: null,
  serviceCenterId: null,
  serviceOrderGroupId: null,
  recipientId: null,
  technicanId: null,
  contactInformation: {
    id: 'driver-customer-id',
    name: 'John Driver',
    email: 'john.driver@example.com',
    phoneNumber: {
      countryCode: 'CZE',
      prefix: '+420',
      number: '777888999',
    },
    identityCard: 'ID123456',
  },
  totalPriceEstimated: {
    amount: 1000,
    currency: 'CZK',
  },
};

export const emptyServiceOrderMock = {
  ...serviceOrderMock,
  completionAt: null,
  totalPriceEstimated: null,
  mileage: null,
  fuelTank: null,
  serviceOrderGroupId: null,
  serviceCenterId: null,
};
